import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import sideTabs from "assets/json/sideWindowTabs.json";
import tabs from "assets/json/tabs.json";

const useRedirect = () => {
	const dispatch = useDispatch();
	const address = useSelector(state => state.window.currentAddress);
	const history = useSelector(state => state.window.history);

	return useMemo(
		() => (path, additionalInformation) => {
			if (path === address) return;
			const splittedAddress = address.split(".");
			const splittedPath = path.split(".");

			const splittedAddressCopy = [...splittedAddress];
			const splittedPathCopy = [...splittedPath];

			if (path === "BACK") {
				if (history.length <= 0 || (history.length === 1 && !history[0])) {
					let newAddress = address.split(".");
					newAddress.pop();

					if (newAddress.length === 1 && newAddress[0] === "noIcon") {
						newAddress = [""];
					}

					dispatch({ type: "SET_WINDOW_ADDRESS", state: newAddress.join(".") });
					return;
				}

				const newHistory = history;
				let newAddress = newHistory.pop();

				if (newHistory[newHistory.length - 1] === address) {
					newAddress = newHistory.pop();
					if (address === newAddress) newAddress = newHistory[newHistory.length - 1];
				}

				dispatch({ type: "SET_WINDOW_HISTORY", state: newHistory });
				dispatch({ type: "SET_WINDOW_ADDRESS", state: newAddress, preserveHistory: false });
				return;
			}

			if (address.includes("~")) {
				let i = 0;
				while (splittedAddressCopy.length > 0 && splittedPathCopy.length > 0) {
					const addressIncludesId = splittedAddressCopy[0].includes("~");
					if (splittedPathCopy[0] !== splittedAddressCopy[0] && splittedPathCopy[0] !== "*" && !addressIncludesId)
						break;

					if (addressIncludesId) {
						if (splittedPathCopy[0].split("~")[0] !== splittedAddressCopy[0].split("~")[0]) break;
						if (!splittedPathCopy[0].includes("~")) {
							splittedPath[i] += `~${splittedAddressCopy[0].split("~")[1]}`;
							path = splittedPath.join(".");
						}
					}

					splittedPathCopy.shift();
					splittedAddressCopy.shift();
					i++;
				}
			}

			if (path.includes("*")) {
				const correctedPath = splittedPath
					.map((t, i) => {
						if (t !== "*" || !splittedAddress[i]) return t;
						return splittedAddress[i];
					})
					.join(".");

				if (additionalInformation) {
					dispatch({ type: "SET_WINDOW_ADDRESS", state: correctedPath, additionalInformation });
					return;
				}

				dispatch({ type: "SET_WINDOW_ADDRESS", state: correctedPath });
				return;
			}

			if (additionalInformation !== undefined) {
				dispatch({ type: "SET_WINDOW_ADDRESS", state: path, additionalInformation });
				return;
			}

			dispatch({ type: "SET_WINDOW_ADDRESS", state: path });
		},
		[address, dispatch, history]
	);
};

const routerOptions = new Map([
	[
		"w",
		{
			tabs,
			addressState: state => state.window.currentAddress,
			historyState: state => state.window.history,
			addressAction: "SET_WINDOW_ADDRESS",
			historyAction: "SET_WINDOW_HISTORY"
		}
	],
	[
		"s",
		{
			tabs: sideTabs,
			addressState: state => state.sideWindow.currentAddress,
			historyState: state => state.sideWindow.history,
			addressAction: "SET_SIDE_WINDOW_ADDRESS",
			historyAction: "SET_SIDE_WINDOW_HISTORY"
		}
	]
]);

const useRedirectNew = options => {
	const dispatch = useDispatch();
	const address = useSelector(options.addressState);
	const history = useSelector(options.historyState);

	return useMemo(
		() => (path, additionalInformation) => {
			if (path === address) return;
			const splittedAddress = address.split(".");
			const splittedPath = path.split(".");

			const splittedAddressCopy = [...splittedAddress];
			const splittedPathCopy = [...splittedPath];

			if (path === "BACK") {
				if (history.length <= 0 || (history.length === 1 && !history[0])) {
					let newAddress = address.split(".");
					newAddress.pop();

					if (newAddress.length === 1 && newAddress[0] === "noIcon") {
						newAddress = [""];
					}

					dispatch({ type: options.addressAction, state: newAddress.join(".") });
					return;
				}

				const newHistory = history;
				let newAddress = newHistory.pop();

				if (newHistory[newHistory.length - 1] === address) {
					newAddress = newHistory.pop();
					if (address === newAddress) newAddress = newHistory[newHistory.length - 1];
				}

				dispatch({ type: options.historyAction, state: newHistory });
				dispatch({ type: options.addressAction, state: newAddress, preserveHistory: false });
				return;
			}

			if (address.includes("~")) {
				let i = 0;
				while (splittedAddressCopy.length > 0 && splittedPathCopy.length > 0) {
					const addressIncludesId = splittedAddressCopy[0].includes("~");
					if (splittedPathCopy[0] !== splittedAddressCopy[0] && splittedPathCopy[0] !== "*" && !addressIncludesId)
						break;

					if (addressIncludesId) {
						if (splittedPathCopy[0].split("~")[0] !== splittedAddressCopy[0].split("~")[0]) break;
						if (!splittedPathCopy[0].includes("~")) {
							splittedPath[i] += `~${splittedAddressCopy[0].split("~")[1]}`;
							path = splittedPath.join(".");
						}
					}

					splittedPathCopy.shift();
					splittedAddressCopy.shift();
					i++;
				}
			}

			if (path.includes("*")) {
				const correctedPath = splittedPath
					.map((t, i) => {
						if (t !== "*" || !splittedAddress[i]) return t;
						return splittedAddress[i];
					})
					.join(".");

				if (additionalInformation) {
					dispatch({ type: options.addressAction, state: correctedPath, additionalInformation });
					return;
				}

				dispatch({ type: options.addressAction, state: correctedPath });
				return;
			}

			if (additionalInformation !== undefined) {
				dispatch({ type: options.addressAction, state: path, additionalInformation });
				return;
			}

			dispatch({ type: options.addressAction, state: path });
		},
		[address, dispatch, history, options.addressAction, options.historyAction]
	);
};

export { useRedirectNew, routerOptions };
export default useRedirect;
